export default __webpack_public_path__ + "static/media/re.b61ab6eb.jpg";